module.exports = __webpack_public_path__ + "img/4_29.afa25aa7.png";